import { render } from "./template6.vue?vue&type=template&id=9bfb6d20"
import script from "./template6.vue?vue&type=script&lang=js"
export * from "./template6.vue?vue&type=script&lang=js"

import "./template6.vue?vue&type=style&index=0&id=9bfb6d20&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__